const API_BASE_URL = process.env.BASE_URL

export const CLIENTS = {
    CREATE_PORTAL_SESSION: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/create-portal-session/",
    LIST_PAYMENT_METHODS: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/payment-methods/",
    SAVE_PAYMENT_METHOD: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/save-payment-method/",
    BALANCE_TRANSACTIONS: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/balance-transactions/",
    SEARCH: API_BASE_URL + "/{service_company_slug}/api/clients/search/",
    CREATE: API_BASE_URL + "/{service_company_slug}/api/clients/",
}

export const CLIENT_LABELS = {
    LIST: API_BASE_URL + "/{service_company_slug}/api/clients/labels/",
}

export const SERVICE_LOCATIONS = {
    SEARCH: API_BASE_URL + "/{service_company_slug}/api/service-locations/search/",
    CREATE: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/service-locations/",
    BILLING_DEFAULTS:
        API_BASE_URL + "/{service_company_slug}/api/service-locations/{service_location_id}/billing-defaults/",
}

export const CONTACTS = {
    CLIENT_LIST: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/contacts/",
    CLIENT_CREATE: API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/contacts/",
    LOCATION_LIST:
        API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/service-locations/{location_id}/contacts/",
    LOCATION_CREATE:
        API_BASE_URL + "/{service_company_slug}/api/clients/{client_id}/service-locations/{location_id}/contacts/",
    LOCATION_COMBINED_LIST:
        API_BASE_URL +
        "/{service_company_slug}/api/clients/{client_id}/service-locations/{location_id}/contacts/combined/",
}

export const EQUIPMENT = {
    SERVICE_LOCATION_LIST:
        API_BASE_URL + "/{service_company_slug}/api/service-locations/{service_location_id}/equipment/",
    SERVICE_LOCATION_CREATE:
        API_BASE_URL + "/{service_company_slug}/api/service-locations/{service_location_id}/equipment/",
    SERVICE_LOCATION_OPTIONS:
        API_BASE_URL + "/{service_company_slug}/api/service-locations/{service_location_id}/equipment/options/",
}
